import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid var(--glass-border);
  background: var(--glass-1);
  backdrop-filter: blur(10px);
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 600px;
`;

const Th = styled.th`
  padding: 20px;
  background: var(--glass-2);
  color: var(--text-primary);
  font-weight: bold;
  border-bottom: 2px solid var(--accent);
  
  img { height: 100px; object-fit: contain; margin-bottom: 15px; }
  .title { font-size: 18px; margin-bottom: 5px; }
  .price { color: var(--accent); font-size: 20px; font-weight: 900; }
`;

const Td = styled.td`
  padding: 15px 20px;
  border-bottom: 1px solid var(--glass-border);
  color: var(--text-secondary);
  font-size: 14px;
`;

const Tr = styled.tr`
  &:hover td { background: rgba(255,255,255,0.02); }
`;

const FeatureLabel = styled.td`
  padding: 15px 20px;
  border-bottom: 1px solid var(--glass-border);
  color: var(--text-primary);
  font-weight: 600;
  font-size: 14px;
  background: rgba(0,0,0,0.1);
  width: 20%;
`;

const DeviceCompareWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Table>
        <thead>
          <tr>
            <Th style={{background: 'rgba(0,0,0,0.2)', verticalAlign: 'bottom', paddingBottom: '30px', fontSize: '24px'}}>Vergleich</Th>
            <Th>
              <img src="https://via.placeholder.com/100x150/1e293b/00A9E0?text=S24" alt="S24"/>
              <div className="title">Galaxy S24</div>
              <div className="price">ab 899 €</div>
            </Th>
            <Th>
              <img src="https://via.placeholder.com/100x150/1e293b/00A9E0?text=S24+" alt="S24+"/>
              <div className="title">Galaxy S24+</div>
              <div className="price">ab 1.149 €</div>
            </Th>
            <Th>
              <img src="https://via.placeholder.com/100x150/1e293b/00A9E0?text=S24U" alt="Ultra"/>
              <div className="title">Galaxy S24 Ultra</div>
              <div className="price">ab 1.449 €</div>
            </Th>
          </tr>
        </thead>
        <tbody>
          <Tr>
            <FeatureLabel>Display</FeatureLabel>
            <Td>6.2" FHD+ AMOLED</Td>
            <Td>6.7" QHD+ AMOLED</Td>
            <Td>6.8" QHD+ AMOLED Flat</Td>
          </Tr>
          <Tr>
            <FeatureLabel>Kamera</FeatureLabel>
            <Td>50 MP</Td>
            <Td>50 MP</Td>
            <Td>200 MP + 5x Optischer Zoom</Td>
          </Tr>
          <Tr>
            <FeatureLabel>Akku</FeatureLabel>
            <Td>4000 mAh</Td>
            <Td>4900 mAh</Td>
            <Td>5000 mAh</Td>
          </Tr>
          <Tr>
            <FeatureLabel>Material</FeatureLabel>
            <Td>Armor Aluminum 2</Td>
            <Td>Armor Aluminum 2</Td>
            <Td>Titanium Frame</Td>
          </Tr>
        </tbody>
      </Table>
    </Wrapper>
  );
};

registry.register('device_compare', {
  label: 'Geräte Vergleich',
  icon: '⚖️',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: DeviceCompareWidget,
  inspectorControls: [
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
